import { normalizeCard } from 'api/normalize';
import {
  LOAD_BOARD_SUCCESS,
  LOAD_CARD_SUCCESS,
  LoadBoardSuccessAction,
  LoadCardSuccessAction,
} from 'modules/loaders';
import { SOCKET_CARD, SocketCardAction } from 'modules/sockets';
import { CardModel } from 'types';
import { createReducer } from 'util/reducers';
import uniqBy from 'util/uniqBy';
import { PERFORM_SEARCH_SUCCESS, PerformSearchSuccessAction } from './search';
import updateModelList from './util/updateModelList';

// Reducer
export type CardState = CardModel[];
const initialState: CardState = [];

export default createReducer(initialState, {
  [LOAD_BOARD_SUCCESS](state, { payload }: LoadBoardSuccessAction) {
    const { cards = [] } = payload;

    return uniqBy(
      cards.map((card) => normalizeCard(card)).concat(state),
      (card) => card.id,
    );
  },

  [LOAD_CARD_SUCCESS](state, { payload }: LoadCardSuccessAction) {
    const card = normalizeCard(payload);
    const existingCard = state.find((c) => c.id === card.id) || {};

    return state
      .filter((c) => c.id !== card.id)
      .concat([{ ...existingCard, ...card }]);
  },

  [SOCKET_CARD](state, { payload }: SocketCardAction) {
    return updateModelList(state, payload, normalizeCard);
  },

  [PERFORM_SEARCH_SUCCESS](state, { payload }: PerformSearchSuccessAction) {
    const { cards = [] } = payload;

    return cards.reduce((result, card) => {
      const idx = result.findIndex((c) => c.id === card.id);
      if (idx === -1) {
        return result.concat([normalizeCard(card)]);
      }
      result[idx] = { ...result[idx], ...normalizeCard(card) };

      return result;
    }, state);
  },
});



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/cards.ts